export const LESSON_LIST_REQUEST = 'LESSON_LIST_REQUEST'
export const LESSON_LIST_SUCCESS = 'LESSON_LIST_SUCCESS'
export const LESSON_LIST_FAILURE = 'LESSON_LIST_FAILURE'
export const LESSON_DETAILS_REQUEST = 'LESSON_DETAILS_REQUEST'
export const LESSON_DETAILS_SUCCESS = 'LESSON_DETAILS_SUCCESS'
export const LESSON_DETAILS_FAILURE = 'LESSON_DETAILS_FAILURE'
export const LESSON_ASSIGN_REQUEST = 'LESSON_ASSIGN_REQUEST'
export const LESSON_ASSIGN_SUCCESS = 'LESSON_ASSIGN_SUCCESS'
export const LESSON_ASSIGN_FAILURE = 'LESSON_ASSIGN_FAILURE'
export const LESSON_DELETE_REQUEST = 'LESSON_DELETE_REQUEST'
export const LESSON_DELETE_SUCCESS = 'LESSON_DELETE_SUCCESS'
export const LESSON_DELETE_FAILURE = 'LESSON_DELETE_FAILURE'
export const TEACHER_IDS_REQUEST = 'TEACHER_IDS_REQUEST'
export const TEACHER_IDS_SUCCESS = 'TEACHER_IDS_SUCCESS'
export const TEACHER_IDS_FAILURE = 'TEACHER_IDS_FAILURE'